
export const searchInputToLowerCase = () => {
    document.querySelectorAll('[role="search"] input[type="search"]').forEach((searchInput) => {
        const searchForm = searchInput.closest("form");
        if (searchForm) {
            searchForm.addEventListener("submit", function () {
                (searchInput as HTMLInputElement).value = (searchInput as HTMLInputElement).value.toLowerCase();
            });
        }
    });
}